import { InterestsSetType } from '../components/InterestsSetEditor/InterestsSetEditor';

import { RetargetingConditionData } from './retargeting';

export enum AudienceTargetingsType {
    audience = 'audience',
    interests = 'interests',
    behaviors = 'behaviors',
    family = 'family',
    goal = 'goal',
    socialDemo = 'socialDemo',
    audienceMetrics = 'audienceMetrics',
    audioGenres = 'audioGenres'
}

export interface AudienceTargetingsValue {
    [AudienceTargetingsType.interests]?: InterestsSetType[];
    [AudienceTargetingsType.socialDemo]?: string[];
    [AudienceTargetingsType.audience]?: string[];
    [AudienceTargetingsType.family]?: string[];
    [AudienceTargetingsType.behaviors]?: string[];
    [AudienceTargetingsType.audienceMetrics]?: RetargetingConditionData;
    [AudienceTargetingsType.audioGenres]?: string[];
}

export interface AudienceTargetingsEditorState {
    templateName: string;
    enabledAudienceTargetingsTypes: AudienceTargetingsType[];
}

export interface InterestsTargetingEditorState {
    isOpen: boolean;
    value: InterestsSetType[];
}

export interface CryptaSocialDemoEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaGroupFamilyEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaBehavioralEditorState {
    isOpen: boolean;
    checkedItems: string[];
}

export interface CryptaAudioGenresEditorState {
    isOpen: boolean;
    checkedItems: string[];
}
